import {Map} from "immutable";
import * as React from "react";
import {connect} from "react-redux";
import {
    allFlashReportsSummariesSelector,
    allManagersSelector,
    hasClientResearchEnabled,
    hasResearchAccess,
    isEditingPlanPortfolio,
    selectProductSummariesBasedOnEditMode,
} from "../../../mainReducerMapSelectors";
import {FlashReportSummary} from "../../model/FlashReportSummary.model";
import {IStrategyUpdate} from "../../model/IStrategyUpdate.model";
import {ManagerResponse} from "../../model/manager/ManagerResponse.model";
import {ProductSummary} from "../../model/product/ProductSummary";
import {ErrorComponent} from "../base/Error.component";
import {getSuccessData} from "../common/commonStates";
import {
    allFlashReportsSummariesRequestPair,
    allManagersRequestPair,
} from "../common/RequesterPairs";
import {FlashReports} from "../flash-report/FlashReports.component";
import {FormattedMessage} from "react-intl";
import {multipleApiRequesterWrapper} from "../common/MultipleApiRequesterWrapper";
import {IApplicationRootState} from "../../../applicationState";
import {ManagerStrategies} from "./ManagerStrategies.component";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";

export interface IManagerComponentPropsFromParent {
    match: {
        params: IManagerPageUrlParams;
    };
}

export interface IManagerPageUrlParams {
    managerId: string;
}

export interface IManagerPagePropsFromStore {
    editingPlanPortfolio: boolean;
    productSummaries: Map<number, ProductSummary> | null;
    allManagers: Map<number, ManagerResponse>;
    allFlashReportSummaries: Map<number, FlashReportSummary>;
    hasClientResearchEnabled: boolean;
    hasResearchAccess: boolean;
}

export type IManagerComponentProps =
    IManagerComponentPropsFromParent &
    IManagerPagePropsFromStore;

export class ManagerPageComponent extends React.Component<IManagerComponentProps> {

    public render() {
        const managerId = Number.parseInt(this.props.match.params.managerId, 10);
        const manager = this.props.allManagers.get(managerId)!;

        if (!this.props.productSummaries) {
            return <LoadingSpinner/>;
        }

        if ((!this.props.hasClientResearchEnabled && !this.props.hasResearchAccess)
            || !this.managerIsAvailable(manager)) {
            return <ErrorComponent/>;
        }

        const renderManagerWebsiteButton = () => {
            const handleClick = () => {
                window.open(manager.website, "_blank");
            };

            return <div className="manager-website__button-container">
                <button className="manager-website__button" onClick={handleClick}>
                    Manager Website
                </button>
            </div>;
        };

        return (
            <div className="wealth-parent main-content manager-container new-common-styles">
                <div id="manager-info" className="manager-info">
                    <div className="manager-header">
                        <h1 id="manager-name">
                            {manager.name} - {/* space */}
                            <FormattedMessage id="manager.firm-summary" defaultMessage="Firm Summary"/>
                        </h1>
                        { manager.website && renderManagerWebsiteButton() }
                    </div>
                    <ManagerStrategies {...{managerId, productSummaries: this.props.productSummaries}}/>
                    <FlashReports flashReportSummaries={this.getFlashReportSummaries()}/>
                </div>
            </div>
        );
    }

    private managerIsAvailable(manager: ManagerResponse | undefined): boolean {
        if (!manager) {
            return false;
        }
        return manager.inPortfolio || this.props.editingPlanPortfolio;
    }

    private getFlashReportSummaries() {
        return this.props.allFlashReportSummaries.valueSeq().toArray()
            .filter(this.isAttachedToManager);
    }

    private isAttachedToManager = (strategyUpdate: IStrategyUpdate) => {
        return strategyUpdate.managerIds.includes(Number.parseInt(this.props.match.params.managerId, 10));
    };
}

export const mapStateToProps = (state: IApplicationRootState): IManagerPagePropsFromStore => {
    return {
        editingPlanPortfolio: isEditingPlanPortfolio(state),
        productSummaries: getSuccessData(selectProductSummariesBasedOnEditMode(state))!,
        allManagers: getSuccessData(allManagersSelector(state))!,
        allFlashReportSummaries: getSuccessData(allFlashReportsSummariesSelector(state))!,
        hasClientResearchEnabled: hasClientResearchEnabled(state),
        hasResearchAccess: hasResearchAccess(state),
    };
};
const connectedComponent = connect<IManagerPagePropsFromStore, null>(mapStateToProps, null)(ManagerPageComponent);

export default multipleApiRequesterWrapper(
    connectedComponent,
    [
        allManagersRequestPair,
        allFlashReportsSummariesRequestPair,
    ],
);
